import React from 'react';
import { findDOMNode } from 'react-dom';
import cx from 'classnames';

export default class SearchInput extends React.Component {
    static defaultProps = {
        value : undefined,
        onFocus: function() {},
        onBlur: function() {},
        onChange: function() {},
        onSearch: function() {}
    };
    
	constructor(props) {
    	super(props);
        
        this.state = {
            initialValue: props.initialValue,
            placeholder: props.placeholder,
            focussed: false
        }

        this.handleOnSearch = this.handleOnSearch.bind(this);
  	}

    componentDidMount() {
        var searchInput = findDOMNode(this.refs.input);
        searchInput.addEventListener("search", this.handleOnSearch);
    }

    componentWillUnmount() {
        var searchInput = findDOMNode(this.refs.input);
        searchInput.removeEventListener("search", this.handleOnSearch);
    }
    
    handleOnFocus(event) {
        this.props.onFocus(event);
        this.setState({focussed: true});
    }
    
    handleOnBlur(event) {
        this.props.onBlur(event);
        this.setState({focussed: false});
    }

    handleOnSearch(event) {
        this.props.onSearch(event.target.value);
    }

    handleOnChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        var { focussed } = this.state;
        var { placeholder } = this.props;
        
        return (
    		<div className={cx("b3-search-container", { "focus" : focussed })}>
                <input ref="input" value={this.props.value} initialValue={this.state.initialValue} type="search" className="b3-input b3-search" onChange={ this.handleOnChange.bind(this) } onFocus={this.handleOnFocus.bind(this)} onBlur={this.handleOnBlur.bind(this)} placeholder={placeholder} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/b3/inputs/SearchInput.js